import { render, staticRenderFns } from "./HighlightCanvas.vue?vue&type=template&id=dbd14250&scoped=true&"
import script from "./HighlightCanvas.vue?vue&type=script&lang=js&"
export * from "./HighlightCanvas.vue?vue&type=script&lang=js&"
import style0 from "./HighlightCanvas.vue?vue&type=style&index=0&id=dbd14250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd14250",
  null
  
)

export default component.exports